export default [
  {
    value: 'id',
    text: 'ID',
    width: 80,
    type: 'number',
    sortable: false,
    description: ''
  },
  {
    value: 'actionAuthor',
    text: 'Автор',
    type: 'string',
    description: ''
  },
  {
    value: 'ip',
    text: 'IP',
    width: 60,
    type: 'string',
    sortable: false,
    description: ''
  },
  {
    value: 'payload',
    text: 'Сущность',
    type: 'string',
    sortable: false,
    description: ''
  },
  {
    value: 'operationName',
    text: 'Название операции',
    width: 160,
    type: 'string',
    description: ''
  },
  {
    value: 'scope',
    text: 'Тип сущности',
    width: 160,
    type: 'string',
    description: ''
  },
  {
    value: 'createdAt',
    text: 'Создано',
    width: 180,
    type: 'date',
    description: ''
  },
  {
    value: 'actions',
    text: 'Подробности',
    width: 60,
    align: 'end',
    type: 'actions',
    sortable: false,
    description: ''
  }
]
